import {
  CheckMetadata,
  CheckMetadataItem,
  CheckMetadataItemType,
  ComparisonCheckType,
  createAttributeComparisonTableCheckMetadatas,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import RiskLevelSticker from 'dashboard/components/RiskLevelSticker';
import { IdAccountComparison } from 'dashboard/models/check';
import { RiskData, RiskLevel } from 'dashboard/models/verification-check';

export const computeIdAccountComparisonMetadata = (check: IdAccountComparison): CheckMetadata => {
  const metadata: CheckMetadataItem[] = [];

  const risks = check.metadata?.['risks'];
  const faceComparisonRiskData = risks?.find((r: RiskData) => r.reason === 'face_mismatch');
  if (faceComparisonRiskData) {
    metadata.push({
      heading: {
        title: 'Face Comparison Risk',
      },
      items: [
        {
          label: 'Risk Level',
          value: RiskLevelSticker({ riskLevel: faceComparisonRiskData['level'] as RiskLevel }),
        },
      ],
      type: CheckMetadataItemType.Group,
    });
  }

  const attributeComparisons = check.metadata?.['attribute-comparisons'];
  if (attributeComparisons) {
    metadata.push(
      ...createAttributeComparisonTableCheckMetadatas(
        attributeComparisons,
        ComparisonCheckType.IdAccountComparison,
      ),
    );
  }

  return {
    metadata: metadata,
    hideIfVerificationPassed: false,
  };
};
